<div class="smooth-scrolling">
    <app-responsive-searchbar-black-border></app-responsive-searchbar-black-border>
    <!-- cancel order section start -->

    <section class="cancel-order">
        <div class="c-order-box">
            <h5>are you sure, you want to cancel this order?</h5>
            <div class="cancel-order-list">
                <div class="cancel-order-box">
                    <span><img src="assets/images/cancel-order-image.png" alt="image" /></span>
                    <div class="c-order-detail">
                        <div class="order-title">Advanced Snail 92 All In One Cream</div>
                        <div class="order-qty">qty: 1</div>
                    </div>
                </div>
                <div class="cancel-order-box">
                    <span><img src="assets/images/cancel-order-image.png" alt="image" /></span>
                    <div class="c-order-detail">
                        <div class="order-title">Advanced Snail 92 All In One Cream</div>
                        <div class="order-qty">qty: 1</div>
                    </div>
                </div>
                <div class="cancel-order-box">
                    <span><img src="assets/images/cancel-order-image.png" alt="image" /></span>
                    <div class="c-order-detail">
                        <div class="order-title">Advanced Snail 92 All In One Cream</div>
                        <div class="order-qty">qty: 1</div>
                    </div>
                </div>
            </div>
            <ul class="cancel-order-link">
                <li><a href="#" class="c-order-black">I want it!</a></li>
                <li><a href="#" class="c-order-border">cancel it!</a></li>
            </ul>
        </div>
    </section>

    <!-- cancel order section end -->

    <!-- Footer START -->

    <app-footer-bg></app-footer-bg>

    <!-- Footer END -->
</div>